import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RevenueTracker = ({ owner }) => {
  const [notes, setNotes] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const handleSaveNotes = () => {
    setIsSaving(true);
    localStorage.setItem(`revenueNotes_${owner?.id}`, notes);
    setTimeout(() => {
      setIsSaving(false);
      alert('تم حفظ الملاحظات بنجاح');
    }, 500);
  };

  const handleExportRevenue = () => {
    alert('جاري تصدير تقرير الإيرادات...');
  };

  const revenueData = [
    {
      id: 1,
      property: 'شقة عبدون - حي عبدون الشمالي',
      amount: '4,500 دينار',
      status: 'مدفوع',
      date: '2026-01-05',
      paymentMethod: 'تحويل بنكي',
    },
    {
      id: 2,
      property: 'فيلا خلدا - حي الجاردنز',
      amount: '8,000 دينار',
      status: 'معلق',
      date: '2026-01-10',
      paymentMethod: 'تحويل بنكي',
    },
    {
      id: 3,
      property: 'محل تجاري - ماركا الجديدة',
      amount: '6,200 دينار',
      status: 'مدفوع',
      date: '2026-01-03',
      paymentMethod: 'شيك',
    },
    {
      id: 4,
      property: 'مكتب إداري - الشميساني',
      amount: '5,500 دينار',
      status: 'متأخر',
      date: '2025-12-28',
      paymentMethod: 'تحويل بنكي',
    },
  ];

  const totalRevenue = revenueData?.reduce((sum, item) => {
    const amount = parseFloat(item?.amount?.replace(/[^\d.]/g, ''));
    return sum + amount;
  }, 0);

  const paidRevenue = revenueData?.filter((item) => item?.status === 'مدفوع')?.reduce((sum, item) => {
      const amount = parseFloat(item?.amount?.replace(/[^\d.]/g, ''));
      return sum + amount;
    }, 0);

  const getStatusColor = (status) => {
    switch (status) {
      case 'مدفوع':
        return 'bg-success/10 text-success border-success/20';
      case 'معلق':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'متأخر':
        return 'bg-error/10 text-error border-error/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  if (!owner) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 text-center">
        <Icon name="DollarSign" size={40} color="var(--color-muted-foreground)" />
        <p className="text-muted-foreground mt-3 text-sm">
          اختر مالكاً لعرض الإيرادات
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Icon name="DollarSign" size={20} color="var(--color-primary)" />
            <h3 className="font-heading font-semibold text-foreground">تتبع الإيرادات</h3>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={handleExportRevenue}
            iconName="Download"
            iconSize={16}
          >
            تصدير
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="p-4 rounded-lg bg-primary/5 border border-primary/20">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="DollarSign" size={18} color="var(--color-primary)" />
              <p className="text-xs text-muted-foreground">إجمالي الإيرادات</p>
            </div>
            <p className="text-xl md:text-2xl font-data font-bold text-foreground">
              {totalRevenue?.toLocaleString('ar-SA')} ريال
            </p>
          </div>

          <div className="p-4 rounded-lg bg-success/5 border border-success/20">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="CheckCircle" size={18} color="var(--color-success)" />
              <p className="text-xs text-muted-foreground">المدفوع</p>
            </div>
            <p className="text-xl md:text-2xl font-data font-bold text-success">
              {paidRevenue?.toLocaleString('ar-SA')} ريال
            </p>
          </div>

          <div className="p-4 rounded-lg bg-warning/5 border border-warning/20">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Clock" size={18} color="var(--color-warning)" />
              <p className="text-xs text-muted-foreground">المعلق</p>
            </div>
            <p className="text-xl md:text-2xl font-data font-bold text-warning">
              {(totalRevenue - paidRevenue)?.toLocaleString('ar-SA')} ريال
            </p>
          </div>
        </div>
      </div>
      <div className="p-4 md:p-6">
        <div className="space-y-3">
          {revenueData?.map((item) => (
            <div
              key={item?.id}
              className="p-4 rounded-lg border border-border hover:bg-muted transition-colors"
            >
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
                <div className="flex-1">
                  <h4 className="font-medium text-foreground text-sm md:text-base mb-1">
                    {item?.property}
                  </h4>
                  <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
                    <span className="font-data">{item?.date}</span>
                    <span>•</span>
                    <span>{item?.paymentMethod}</span>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <div className="text-left">
                    <p className="text-lg font-data font-bold text-foreground">
                      {item?.amount}
                    </p>
                  </div>
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-caption border whitespace-nowrap ${getStatusColor(
                      item?.status
                    )}`}
                  >
                    {item?.status}
                  </span>
                </div>
              </div>
            </div>
          ))}
          <div className="mt-6 space-y-3">
            <label className="block text-sm font-medium text-foreground">ملاحظات الإيرادات</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e?.target?.value)}
              placeholder="أضف ملاحظات حول الإيرادات..."
              className="w-full px-4 py-3 bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/50 text-foreground min-h-[100px] resize-none"
            />
            <Button
              variant="primary"
              size="sm"
              onClick={handleSaveNotes}
              disabled={isSaving}
              iconName="Save"
              iconSize={16}
              className="w-full"
            >
              {isSaving ? 'جاري الحفظ...' : 'حفظ الملاحظات'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevenueTracker;